module.exports = __webpack_public_path__ + "static/mantle_of_spell_resistance-25bdcc16825bc83f74393a9a883bf540.jpeg";